<div class="govuk-!-margin-bottom-9">
  <govuk-table [columns]="tableColumns()" [data]="products()">
    <ng-template let-column="column" let-row="row">
      @switch (column.field) {
        @case ('productName') {
          @if (readOnly()) {
            {{ row[column.field] }}
          } @else {
            <a class="govuk-link" [routerLink]="['add-product']">{{ row[column.field] }}</a>
          }
        }

        @case ('productStatus') {
          <div class="govuk-!-width-full">
            <govuk-tag [color]="row[column.field] | productStatusColor">
              {{ row[column.field] | titlecase }}
            </govuk-tag>
          </div>
        }

        @case ('energyIntensity') {
          {{ calculateEnergyIntensity(row) }} {{ facilityThroughputUnit() | measurementTypeToUnit }}/{{
            row['throughputUnit']
          }}
        }

        @case ('actions') {
          @if (canAlterProducts()) {
            @switch (row['productStatus']) {
              @case ('LIVE') {
                <a class="govuk-link" [routerLink]="['exclude-product', row.productName]">Exclude</a>
              }

              @case ('EXCLUDED') {
                <a class="govuk-link" [routerLink]="['undo-product', row.productName]">Undo</a>
              }

              @default {
                <a class="govuk-link" [routerLink]="['delete-product', row.productName]">Delete</a>
              }
            }
          }
        }

        @case ('baselineYear') {
          {{ row[column.field] }}
        }

        @default {
          {{ row[column.field] | number }}
        }
      }
    </ng-template>
  </govuk-table>
</div>
